import type { DisciplineInKid } from '@brighterly/lib-core-types/discipline/interfaces'
import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'

import { useCustomerStore } from '@stores/me/customer'
import { useDisciplineStore } from '@stores/discipline'
import { useKidStore } from '@stores/kid'

import { useMiddlewareDisciplineInfo } from '@composables/middleware/discipline-info.hook'

export default defineNuxtRouteMiddleware(async (to) => {
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()
  const customerStore = useCustomerStore()

  let discipline: DisciplineInKid | null
  let kid: KidInCustomer | null

  const firstKid = customerStore.getKids?.[0]
  const firstDiscipline = firstKid?.disciplines[0]
  // FIXME: we have activeDiscipline.id but haven't getDisciplineInfo
  if (!disciplineStore.getDisciplineInfo) {
    const queryDisciplineId = Number(to.query?.discipline_id)
    if (queryDisciplineId) {
      const kids = customerStore.getKids
      const currentDiscipline = customerStore.getKids
        .flatMap((kid) => kid.disciplines || [])
        .find((discipline) => discipline.id === queryDisciplineId)

      if (currentDiscipline) {
        kid = kids.find((kid) => kid.disciplines.includes(currentDiscipline)) || null
        discipline = currentDiscipline
      } else {
        kid = firstKid || null
        discipline = firstDiscipline || null
      }
    } else {
      kid = firstKid || null
      discipline = firstDiscipline || null
    }

    disciplineStore.setActiveDiscipline(discipline || null)
    if (kid) kidStore.setActiveKid(kid.id)
    useMiddlewareDisciplineInfo()
  }
})
